import { sendEmail } from '../../lib/api/send-email'
import { SendEmailInput } from '../../lib/types/models/mail/create-mail-attachment'
import { API } from '../apis.config'

export const radSendEmailToStaffs = async (input: SendEmailInput) => {
  return sendEmail(API.rads.sendEmailToStaffs.url, input)
}
